import type { ScreenModule } from "../../../app/screen-module";
import { TenantStoragePage } from "../pages";

export default {
	id: "tenant-admin.storage",
	path: "/admin/storage",
	area: "tenant-admin",
	navGroup: "管理",
	label: "保管庫",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: TenantStoragePage,
} satisfies ScreenModule;
